import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('portal_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('portal_token');
      localStorage.removeItem('portal_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
  changePassword: (data) => api.post('/auth/change-password', data),
};

export const dashboardAPI = {
  summary: (params) => api.get('/dashboard/summary', { params }),
  trend: (params) => api.get('/dashboard/trend', { params }),
  modules: (params) => api.get('/dashboard/modules', { params }),
  topPassengers: (params) => api.get('/dashboard/top-passengers', { params }),
  flights: (params) => api.get('/dashboard/flights', { params }),
  hotels: (params) => api.get('/dashboard/hotels', { params }),
  transfers: (params) => api.get('/dashboard/transfers', { params }),
  carrentals: (params) => api.get('/dashboard/carrentals', { params }),
};

export default api;
